<template>
  <div class="ICountUp">
    <div class="sci-home-wrap1">
      <div class="sci-home-principal">
        <v-container grid-list-md text-xs-center>
          <v-layout row wrap>
            <v-flex xs12>
              <v-card flat color="transparent">
                <v-card-text class="px-0">
                  <div>
                    <span class="headline">¡BIENVENIDOS!</span>
                  </div>
                  <br />
                  <div class="text-xs-center">
                    <v-layout>
                      <v-flex
                        v-if="centerWidth > 633 || centerHeight > 633"
                        class="subheading"
                      >
                        El Servicio Estatal de Información Científica,
                        Tecnológica e Innovación SEICTI, es una plataforma para
                        el registro de investigadores, instituciones y empresas
                        con actividad en científica y tecnológica. El SEICTI, es
                        también el acceso para el lanzamiento y participación en
                        Convocatorias emitidas por el COCyTED sobre apoyos
                        institucionales, del Sistema Estatal de Investigadores y
                        otros apoyos de fortalecimiento a la actividad
                        científica y tecnológica.
                      </v-flex>
                      <v-flex v-else class="caption">
                        El Servicio Estatal de Información Científica,
                        Tecnológica e Innovación SEICTI, es una plataforma para
                        el registro de investigadores, instituciones y empresas
                        con actividad en científica y tecnológica. El SEICTI, es
                        también el acceso para el lanzamiento y participación en
                        Convocatorias emitidas por el COCyTED sobre apoyos
                        institucionales, del Sistema Estatal de Investigadores y
                        otros apoyos de fortalecimiento a la actividad
                        científica y tecnológica.
                      </v-flex>
                    </v-layout>
                  </div>
                  <div>
                    <br />
                    <v-layout fluid row wrap text-xs-center>
                      <v-spacer></v-spacer>
                      <v-flex xs12 sm6 md4>
                        <v-btn
                          round
                          block
                          color="#0084ff"
                          dark
                          @click="dialog = !dialog"
                        >
                          regístrate
                        </v-btn>

                        <v-dialog v-model="dialog" max-width="500px">
                          <v-card>
                            <v-card-text>
                              <div class="text-xs-right">
                                <v-spacer></v-spacer
                                ><v-icon color="primary" @click="dialog = false"
                                  >close</v-icon
                                >
                              </div>
                              <div>
                                <v-list two-line subheader>
                                  <v-subheader>Registrarme como:</v-subheader>
                                  <v-list-tile
                                    v-for="item in items"
                                    :key="item.title"
                                  >
                                    <v-list-tile-avatar>
                                      <v-icon :class="[item.iconClass]">{{
                                        item.icon
                                      }}</v-icon>
                                    </v-list-tile-avatar>
                                    <v-list-tile-content>
                                      <v-list-tile-title>{{
                                        item.title
                                      }}</v-list-tile-title>
                                    </v-list-tile-content>

                                    <v-list-tile-action>
                                      <v-btn icon ripple>
                                        <v-icon
                                          color="grey lighten-1"
                                          @click="linkToRegister(item.link)"
                                          >east</v-icon
                                        >
                                      </v-btn>
                                    </v-list-tile-action>
                                  </v-list-tile>
                                </v-list>
                              </div>
                            </v-card-text>
                          </v-card>
                        </v-dialog>
                      </v-flex>
                      <v-spacer></v-spacer>

                      <v-flex xs12 sm6 md4>
                        <v-btn
                          color="#0084ff"
                          dark
                          block
                          round
                          :href="configuracion.manual"
                        >
                          ver tutorial
                          <v-icon right small>play_circle</v-icon>
                        </v-btn>
                      </v-flex>
                      <v-spacer></v-spacer>
                      <!-- <v-dialog v-model="dialog2">
                        <v-card>
                          <v-card-title><v-spacer></v-spacer><v-icon color="primary" @click="dialog2 = false">close</v-icon></v-card-title>
                          <iframe v-if="dialog2 == true" width="100%" height="500" src="https://www.youtube.com/embed/U2cilYHAc5A" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                        </v-card>  
                      </v-dialog>   -->
                    </v-layout>
                  </div>
                </v-card-text>
              </v-card>
            </v-flex>
          </v-layout>
        </v-container>
        <!-- Este es el diagrama del HomePage -->
        <v-container justify-center align-center text-xs-center>
          <v-img :src="require('@/assets/diagrama_seicti_2023.png')">
            <router-link tag="a" to="/investigadores">
              <a
                style="
                  position: absolute;
                  top: 5%;
                  left: 22%;
                  height: 20%;
                  width: 20%;
                "
              ></a>
            </router-link>
            <router-link tag="a" to="/organizaciones">
              <a
                style="
                  position: absolute;
                  top: 5%;
                  right: 28%;
                  height: 20%;
                  width: 20%;
                "
              ></a>
            </router-link>
            <router-link tag="a" to="/academicas">
              <a
                style="
                  position: absolute;
                  top: 23%;
                  right: 7%;
                  height: 22%;
                  width: 20%;
                "
              ></a>
            </router-link>
            <router-link tag="a" to="/gubernamental">
              <a
                style="
                  position: absolute;
                  top: 50%;
                  right: 6%;
                  height: 22%;
                  width: 20%;
                "
              ></a>
            </router-link>
            <router-link tag="a" to="/productividad">
              <a
                style="
                  position: absolute;
                  top: 73%;
                  right: 22%;
                  height: 22%;
                  width: 20%;
                "
              ></a>
            </router-link>
            <router-link tag="a" to="/proyectos-de-investigacion">
              <a
                style="
                  position: absolute;
                  top: 73%;
                  left: 33%;
                  height: 22%;
                  width: 20%;
                "
              ></a>
            </router-link>
            <router-link tag="a" to="/convocatorias">
              <a
                style="
                  position: absolute;
                  top: 60%;
                  left: 10%;
                  height: 22%;
                  width: 20%;
                "
              ></a>
            </router-link>
            <router-link tag="a" to="/redes_tematicas">
              <a
                style="
                  position: absolute;
                  top: 30%;
                  left: 5%;
                  height: 22%;
                  width: 20%;
                "
              ></a>
            </router-link>
          </v-img>

          <!-- <v-img usemap="" class="image" :src="require('@/assets/diagrama_seicti_2023.png')" style="width: 90%; height: 87%;">
                        <router-link tag="a" to="/investigadores"> 
                            <a  style="background-color: red; position:absolute; top: 35%; right: 18%; height:10%; width: 10%;"></a>
                        </router-link>
                    </v-img> -->

          <!-- <img style="width: 90%; height: 87%;" src="../assets/diagrama_seicti_2023.png" usemap="#image-map">

          <map name="image-map">
              <area target="_blank" alt="Investigadores" title="Investigadores" href="/" coords="628,205,NaN" shape="circle">
          </map> -->
          <!-- <v-img
         usemap="#investigadores"
         style="width: 90%; height: 87%;"
         :src="require('@/assets/diagrama_seicti_2023.png')"
         >
         </v-img> -->
          <!-- <map name="investigadores">
            <area style="background-color: #666;" shape="rect" coords="10,10,10,10" href="link" alt="holaaa">
        </map> -->
        </v-container>
      </div>
    </div>
    <!-- TERMINA SLIDER -->
    <!-- INICIAN CONVOCATORIAS  -->
    <v-parallax height="500" :src="require('@/assets/sector1.jpg')">
      <v-layout align-end column justify-center>
        <h1 class="display-2 font-weight-bold mb-3">Convocatorias</h1>
        <router-link to="/convocatorias">
          <v-btn dark outline bottom center>
            Ver Convocatorias
            <v-icon right>arrow_right</v-icon>
          </v-btn>
        </router-link>
      </v-layout>
    </v-parallax>
    <!-- INICIAN AREAS DEL CONOCIMIENTO -->
    <v-hover>
      <v-card
        color="#f4f3ef"
        slot-scope="{ hover }"
        :class="`elevation-${hover ? 12 : 0}`"
        class="mx-auto"
        :height="
          $vuetify.breakpoint.xl ||
          $vuetify.breakpoint.lg ||
          $vuetify.breakpoint.md
            ? '320'
            : ''
        "
      >
        <v-card-text>
          <v-container grid-list-lg text-xs-center>
            <v-layout row wrap>
              <v-flex xs12 sm6 md4>
                <div class="sci-home-title1">
                  <p>
                    <span class="display-3 font-weight-bold">
                      <animated-number
                        :value="indicadores.investigadores_total"
                        :formatValue="formatToPrice"
                        :duration="duration"
                      />
                    </span>
                  </p>
                  <p>
                    <span class="headline font-weight-bold">PADRÓN CTI</span>
                  </p>
                </div>
              </v-flex>
              <v-flex xs12 sm6 md4>
                <div class="sci-home-title2">
                  <p>
                    <span class="display-3 font-weight-bold">
                      <animated-number
                        :value="339"
                        :formatValue="formatToPrice"
                        :duration="duration"
                      />
                    </span>
                  </p>
                        <!--
                          en value indica la cantidad de investigadores sni, no la calcula, esta como cantidad fija
                          la cantidad anterior era 298, segun reporte 2024 son 339
                        -->
                  <p>
                    <span class="headline font-weight-bold">
                      SISTEMA NACIONAL DE INVESTIGADORES
                    </span>
                    <br>
                      <span style="font-size:small" >Reporte del 8 de julio de 2024.</span>
                  </p>
                  <v-tooltip bottom color="black">
                    <template v-slot:activator="{ on }">
                      <v-btn
                        style="text-transform: capitalize"
                        depressed
                        v-on="on"
                        v-bind:href="fileSNI.url"
                        target="_blank"
                      >
                        Descargar documento
                        <v-icon right color="light-blue" dark>
                          cloud_download</v-icon>
                      </v-btn>
                    </template>
                    <span>Click para descargar</span>
                  </v-tooltip>
                </div>
              </v-flex>
              <v-flex xs12 sm6 md4>
                <div class="sci-home-title3">
                  <p>
                    <span class="display-3 font-weight-bold">
                      <animated-number
                        :value="603"
                        :formatValue="formatToPrice"
                        :duration="duration"
                      />
                    </span>
                  </p>
                        <!--
                          en value indica la cantidad de investigadores sei, si la calcula, 
                          pero calcula mal, segun reporte de 5/02/2025, son 603, y mostraba 635
                          se puso fijo igual que el otro mientras se corrije
                        -->
                  <p>
                    <span class="headline font-weight-bold">
                      SISTEMA ESTATAL DE INVESTIGADORES
		    </span>
                    <br>
                    <span style="font-size:small">Reporte del 1 de enero de 2025</span>
                  </p>

                  <v-tooltip bottom color="black">
                    <template v-slot:activator="{ on }">
                      <v-btn
                        style="text-transform: capitalize"
                        depressed
                        v-on="on"
                        v-bind:href="fileSEI.url"
                        target="_blank"
                      >
                        Descargar documento
                        <v-icon right color="light-blue " dark
                          >cloud_download</v-icon
                        >
                      </v-btn>
                    </template>
                    <span>Click para descargar</span>
                  </v-tooltip>
                </div>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-hover>
    <!-- <div class="sci-home-areas">
      <v-container grid-list-md text-xs-center>
        <v-layout row wrap>
          <v-flex xs12 sm4 md4>
            <div class="sci-home-title1">
              <p>
                <span class="sci-home-areaSpan2">
                  <animated-number
                    :value="indicadores.investigadores_total"
                    :formatValue="formatToPrice"
                    :duration="duration"
                  />
                </span>
              </p>
              <p class="sci-home-areap1">
                <span class="sci-home-areaSpan3">PADRÓN CTI</span>
              </p>
            </div>
          </v-flex>
          <v-flex xs12 sm4 md4>
            <div class="sci-home-title2">
              <p>
                <span class="sci-home-areaSpan2">
                  <animated-number
                    :value="243"
                    :formatValue="formatToPrice"
                    :duration="duration"
                  />
                </span>
              </p>
              <p class="sci-home-areap1">
                <span class="sci-home-areaSpan3"
                  >SISTEMA NACIONAL DE INVESTIGADORES</span
                >
              </p>
              <v-tooltip bottom color="black">
                <template v-slot:activator="{ on }">
                  <v-btn
                    style="text-transform: capitalize"
                    color="#fff"
                    flat
                    small
                    v-on="on"
                    v-bind:href="fileSNI.url"
                    target="_blank"
                  >
                    Descargar documento
                    <v-icon right color="light-blue" dark
                      >cloud_download</v-icon
                    >
                  </v-btn>
                </template>
                <span>Click para descargar</span>
              </v-tooltip>
            </div>
          </v-flex>
          <v-flex xs12 sm4 md4>
            <div class="sci-home-title3">
              <p>
                <span class="sci-home-areaSpan2">
                  <animated-number
                    :value="indicadores.sei_total"
                    :formatValue="formatToPrice"
                    :duration="duration"
                  />
                </span>
              </p>
              <p class="sci-home-areap1">
                <span class="sci-home-areaSpan3"
                  >SISTEMA ESTATAL DE INVESTIGADORES</span
                >
              </p>

              <v-tooltip bottom color="black">
                <template v-slot:activator="{ on }">
                  <v-btn
                    style="text-transform: capitalize"
                    color="#fff"
                    flat
                    small
                    v-on="on"
                    v-bind:href="fileSEI.url"
                    target="_blank"
                  >
                    Descargar documento
                    <v-icon right color="light-blue " dark
                      >cloud_download</v-icon
                    >
                  </v-btn>
                </template>
                <span>Click para descargar</span>
              </v-tooltip>
            </div>
          </v-flex>
        </v-layout>
      </v-container>
    </div> -->
    <!-- INICIAN CUADROS DE BIENVENIDA -->
    <div class="sci-home-bienCuadros">
      <v-container fluid>
        <v-layout row wrap>
          <v-flex xs12 sm6 md3 order-md1 order-sm2>
            <v-hover>
              <v-card
                slot-scope="{ hover }"
                :class="`elevation-${hover ? 12 : 0}`"
                class="mx-auto"
                dark
                tile
                flat
                color="grey"
                height="150"
              >
                <router-link to="/investigadores">
                  <v-card-text
                    ><span class="headline font-weight-bold white--text"
                      >Investigadores</span
                    ></v-card-text
                  >
                  <v-card-actions class="pt-4">
                    <v-spacer></v-spacer>
                    <v-icon large>groups</v-icon>
                    <v-spacer></v-spacer>
                  </v-card-actions>
                </router-link>
              </v-card>
            </v-hover>
          </v-flex>
          <v-flex xs12 sm6 md3 order-md2 order-sm1>
            <v-hover>
              <v-card
                slot-scope="{ hover }"
                :class="`elevation-${hover ? 12 : 0}`"
                class="mx-auto"
                tile
                flat
                color="#f4f3ef"
                height="150"
              >
                <router-link to="/proyectos-de-investigacion">
                  <v-card-text
                    ><span class="headline font-weight-bold black--text"
                      >Proyectos de Investigación</span
                    ></v-card-text
                  >
                  <v-card-actions class="pt-4">
                    <v-spacer></v-spacer>
                    <v-icon large color="black">science</v-icon>
                    <v-spacer></v-spacer>
                  </v-card-actions>
                </router-link>
              </v-card>
            </v-hover>
          </v-flex>
          <v-flex xs12 sm6 md3 order-md3 order-sm4>
            <v-hover>
              <v-card
                slot-scope="{ hover }"
                :class="`elevation-${hover ? 12 : 0}`"
                class="mx-auto"
                dark
                tile
                flat
                color="grey"
                height="150"
              >
                <router-link to="/productividad">
                  <v-card-text
                    ><span class="headline font-weight-bold white--text"
                      >Productividad científica</span
                    ></v-card-text
                  >
                  <v-card-actions class="pt-4">
                    <v-spacer></v-spacer>
                    <v-icon large>local_library</v-icon>
                    <v-spacer></v-spacer>
                  </v-card-actions>
                </router-link>
              </v-card>
            </v-hover>
          </v-flex>
          <v-flex xs12 sm6 md3 order-md4 order-sm3>
            <v-hover>
              <v-card
                slot-scope="{ hover }"
                :class="`elevation-${hover ? 12 : 0}`"
                class="mx-auto"
                tile
                flat
                color="#f4f3ef"
                height="150"
              >
                <router-link to="/indicadores">
                  <v-card-text
                    ><span class="headline font-weight-bold black--text"
                      >Indicadores</span
                    ></v-card-text
                  >
                  <v-card-actions class="pt-4">
                    <v-spacer></v-spacer>
                    <v-btn icon large>
                      <v-icon large color="black">show_chart</v-icon>
                    </v-btn>

                    <v-spacer></v-spacer>
                  </v-card-actions>
                </router-link>
              </v-card>
            </v-hover>
          </v-flex>
        </v-layout>
      </v-container>
    </div>
    <!-- TERMINA BIENVENIDA -->
  </div>
</template>

<script>
import AnimatedNumber from "animated-number-vue";
import ICountUp from "vue-countup-v2";
import axios from "axios";
import { mapState, mapMutations, mapActions } from "vuex";
export default {
  components: {
    ICountUp,
    AnimatedNumber,
  },
  props: ["configuracion"],
  data() {
    return {
      centerWidth: document.documentElement.clientWidth,
      centerHeight: document.documentElement.clientHeight,
      dialog2: false,
      items: [
        {
          icon: "search",
          iconClass: "orange lighten-1 white--text",
          title: "Investigador",
          link: "https://acceso-seicti.cocyted.mx/register",
        },
        {
          icon: "person",
          iconClass: "blue lighten-1 white--text",
          title: "Profesional CTI",
          link: "https://acceso-seicti.cocyted.mx/registro-profesional",
        },
        {
          icon: "school",
          iconClass: "blue darken-1 white--text",
          title: "Estudiante de Posgrado",
          link: "https://acceso-seicti.cocyted.mx/registro-posgrado",
        },
        {
          icon: "groups",
          iconClass: "purple lighten-1 white--text",
          title: "Empresa | Asociación | ONG | Clúster",
          link: "https://acceso-seicti.cocyted.mx/registro-empresa",
        },
        {
          icon: "account_balance",
          iconClass: "blue darken-3 white--text",
          title: "Institución Gubernamental",
          link: "https://acceso-seicti.cocyted.mx/registro-gob",
        },
      ],
      dialog: false,
      fileSNI: "",
      fileSEI: "",
      indicadores: {},
      convocatorias: [],
      sni: 0,
      sei: 0,
      value: 1000,
      duration: 2000,
    };
  },
  created() {
    this.getIndicadores();
    this.getSni();
    this.getSei();
    this.getFileSNI();
    this.getFileSEI();
  },
  destroyed() {},
  methods: {
    formatToPrice(value) {
      return `${Number(value).toFixed(0)}`;
    },
    getIndicadores() {
      var urlIndicadores =
        "https://acceso-seicti.cocyted.mx/api/indicadores-totales";
      axios.get(urlIndicadores).then((response) => {
        this.indicadores = response.data;
      });
    },
    listarAreas() {
      var urlArea = "https://acceso-seicti.cocyted.mx/api/areas";
      axios.get(urlArea).then((response) => {
        this.area = response.data;
      });
    },
    getSni() {
      var urlArea = "https://acceso-seicti.cocyted.mx/api/count-sni";
      axios.get(urlArea).then((response) => {
        this.sni = response.data;
      });
    },
    getSei() {
      var urlArea = "https://acceso-seicti.cocyted.mx/api/count-sei";
      axios.get(urlArea).then((response) => {
        this.sei = response.data;
      });
    },
    getRegister() {
      window.open("https://acceso-seicti.cocyted.mx");
    },
    linkToRegister(link) {
      window.open(link);
    },
    getFileSNI() {
      var urlSNI = "https://acceso-seicti.cocyted.mx/api/webfiles-SNI";
      axios.get(urlSNI).then((response) => {
        this.fileSNI = response.data;
      });
    },
    getFileSEI() {
      var urlSEI = "https://acceso-seicti.cocyted.mx/api/webfiles-SEI";
      axios.get(urlSEI).then((response) => {
        this.fileSEI = response.data;
      });
    },
    ...mapMutations([]),
    ...mapActions(["getInvestigadores"]),
  },
  computed: {
    ...mapState(["areas"]),
  },
  mounted() {
    window.onresize = () => {
      this.centerWidth = document.documentElement.clientWidth;
      this.centerHeight = document.documentElement.clientHeight;
    };
  },
};
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
.cls-1 {
  isolation: isolate;
}
.cls-2,
.cls-3,
.cls-34,
.cls-4 {
  fill: none;
  stroke-miterlimit: 10;
}
.cls-2 {
  stroke: #b0b0b0;
  stroke-width: 4.99px;
}
.cls-3,
.cls-4 {
  stroke: #c9c9c9;
}
.cls-3 {
  stroke-width: 0.83px;
}
.cls-4 {
  stroke-width: 0.98px;
}
.cls-5 {
  fill: #c9c9c9;
}
.cls-6 {
  fill: url(#linear-gradient);
}
.cls-7 {
  fill: url(#linear-gradient-2);
}
.cls-8 {
  fill: url(#linear-gradient-3);
}
.cls-9 {
  fill: url(#linear-gradient-4);
}
.cls-10,
.cls-15,
.cls-21,
.cls-26,
.cls-31,
.cls-37,
.cls-42,
.cls-50 {
  mix-blend-mode: multiply;
}
.cls-10 {
  fill: url(#radial-gradient);
}
.cls-11 {
  fill: url(#linear-gradient-5);
}
.cls-12 {
  fill: url(#linear-gradient-6);
}
.cls-13 {
  fill: url(#linear-gradient-7);
}
.cls-14 {
  fill: url(#Degradado_sin_nombre_40);
}
.cls-15 {
  fill: url(#radial-gradient-2);
}
.cls-16 {
  fill: url(#linear-gradient-8);
}
.cls-17 {
  fill: url(#Degradado_sin_nombre_40-2);
}
.cls-18 {
  fill: #fff;
}
.cls-19 {
  fill: url(#linear-gradient-9);
}
.cls-20 {
  fill: url(#linear-gradient-10);
}
.cls-21 {
  fill: url(#radial-gradient-3);
}
.cls-22 {
  fill: url(#linear-gradient-11);
}
.cls-23 {
  fill: url(#linear-gradient-12);
}
.cls-24 {
  fill: url(#linear-gradient-13);
}
.cls-25 {
  fill: url(#linear-gradient-14);
}
.cls-26 {
  fill: url(#radial-gradient-4);
}
.cls-27 {
  fill: url(#linear-gradient-15);
}
.cls-28 {
  fill: url(#linear-gradient-16);
}
.cls-29 {
  fill: url(#linear-gradient-17);
}
.cls-30 {
  fill: url(#linear-gradient-18);
}
.cls-31 {
  fill: url(#radial-gradient-5);
}
.cls-32 {
  fill: url(#linear-gradient-19);
}
.cls-33 {
  fill: url(#linear-gradient-20);
}
.cls-34 {
  stroke: #fff;
}
.cls-35 {
  fill: url(#linear-gradient-21);
}
.cls-36 {
  fill: url(#Degradado_sin_nombre_27);
}
.cls-37 {
  fill: url(#radial-gradient-6);
}
.cls-38 {
  fill: url(#linear-gradient-22);
}
.cls-39 {
  fill: url(#Degradado_sin_nombre_27-2);
}
.cls-40 {
  fill: url(#linear-gradient-23);
}
.cls-41 {
  fill: url(#linear-gradient-24);
}
.cls-42 {
  fill: url(#radial-gradient-7);
}
.cls-43 {
  fill: url(#linear-gradient-25);
}
.cls-44 {
  fill: url(#linear-gradient-26);
}
.cls-45 {
  fill: #00002e;
}
.cls-46 {
  fill: #0081ff;
}
.cls-47 {
  fill: #ffc100;
}
.cls-48 {
  fill: url(#linear-gradient-27);
}
.cls-49 {
  fill: url(#linear-gradient-28);
}
.cls-50 {
  fill: url(#radial-gradient-8);
}
.cls-51 {
  fill: url(#linear-gradient-29);
}
.cls-52 {
  fill: url(#linear-gradient-30);
}

.sci-home-wrap1 {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f3f2ee;
  height: calc(100vh - 79px);
}
.sci-home-principal {
  display: flex;
  align-items: center;
  background-image: url(../assets/light_wallpaper.jpg);
  width: 100vw;
  height: calc(100vh - 79px);
  background-size: cover;
  background-color: #f3f2ee;
}
.slider {
  z-index: 1;
}
.sci-home-bienvenido {
  height: 73vh;
  /* max-height: 820px;
  min-height: 820px; */
  width: 100%;
  position: relative;
  top: 0;
}
.sci-home-bienTitle {
  height: 100%;
  width: 100%;
  background: #00002e;
}
.sci-home-pTitle {
  margin: 0 auto;
  padding: 6% 0 0% 0;
  font-size: 3.5em;
  color: #fff;
  text-transform: uppercase;
  letter-spacing: 2px;
}
.sci-home-pTitle2 {
  font-size: 2em;
  text-transform: uppercase;
  color: #fff;
  font-family: "Lato";
  line-height: 1;
}
.sci-home-pTitle3 {
  width: 45%;
  margin: 3.8% auto;
  color: #fff;
  font-size: 1.4rem;
  line-height: 1.2;
}
.sci-home-bienCuadros {
  margin: 40px;
}
.sci-home-linksCuadros {
  text-decoration: none !important;
}
.sci-home-cuadro1 p,
.sci-home-cuadro2 p,
.sci-home-cuadro3 p,
.sci-home-cuadro4 p {
  font-size: 1.65rem;
  color: #fff;
  text-transform: uppercase;
  padding: 9% 0 0;
}
.sci-home-cuadro1 img,
.sci-home-cuadro2 img,
.sci-home-cuadro3 img,
.sci-home-cuadro4 img {
  width: 115px;
  margin-top: 9%;
}
.sci-home-cuadro1 {
  background: #1c3d70;
  height: 100%;
}
.sci-home-cuadro2 {
  background: #ffd400;
  height: 100%;
}
.sci-home-cuadro3 {
  background: #41ad49;
  height: 100%;
}
.sci-home-cuadro4 {
  background: #008eb6;
  height: 100%;
}
.sci-home-bienImg {
  width: 50px;
}
.sci-h-areasConocimiento {
  /* height: 41vh; */
  /* max-height: 480px;
  min-height: 480px; */
}
.sci-home-areasParrafo {
  width: 45%;
  margin: 0 25% 40px 25%;
  text-align: center;
  font-size: 1.5em;
  line-height: 1.2;
}
.sci-home-indicadores {
  background: rgb(24, 49, 88);
  padding: 1rem;
  color: #fff;
  text-transform: uppercase;
}
.sci-home-areas {
  background: #1c3d70;
}
.sci-home-title-contAreas {
  width: 82%;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  align-content: start;
  margin: 3.6% auto;
  align-content: center;
  grid-gap: 8%;
}
.sci-home-title1,
.sci-home-title2,
.sci-home-title3 {
  display: grid;
  align-content: first baseline;
  justify-content: center;
  font-size: 1.8em;
  text-transform: uppercase;
  padding: 3px;
}
.sci-home-areaSpan1 {
  text-transform: uppercase;
  font-size: 2.7em;
}
.sci-home-areaSpan2 {
  width: 100%;
  font-size: 2.8em;
  font-weight: bold;
  color: #fff;
}
.sci-home-areap1 {
  margin-top: -5%;
  color: #fff;
}
.sci-home-areaSpan3 {
  font-size: 1.5rem;
  margin-top: -4%;
}
.sci-home-areap2 {
  color: #fff;
  font-size: 1.4rem;
  line-height: 0.65;
}
.sci-home-Convocatorias {
  background-image: url("../assets/sector1.jpg");
  background-size: cover;
}
.sci-home-tConvocatorias {
  font-size: 2em;
  color: #fff;
  text-transform: uppercase;
  font-weight: bold;
  text-align: right;
}
.sci-home-convocatoriasBtn {
  width: 100%;
  padding: 10px 0 0 450px;
}
.sci-home-convocatoriasBtn a {
  display: inline-block;
  text-decoration: none !important;
}
.sci-home-verConvocatorias {
  font-size: 2em;
  padding: 8px 35px;
  border-radius: 7px;
  position: relative;
  top: 10%;
  left: 68%;
  color: #fff;
  text-transform: capitalize;
  background: rgba(254, 196, 0, 1);
  text-decoration: none !important;
  cursor: pointer;
}
.sci-home-table2 {
  margin: 3% auto 0 auto;
  border-spacing: 0;
  width: 70%;
  transition: 0.5s ease-in-out;
}
.sci-home-thead2 {
  background: rgba(0, 0, 36, 0.85);
  color: #fff;
  text-transform: uppercase;
}
.sci-home-thead2 tr {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 3fr;
}
.sci-homt-thead tr th {
  padding: 10px 0;
}
.sci-home-tbody2 tr {
  display: grid;
  background: #fff;
  color: #000;
  grid-template-columns: 1fr 1fr 1fr 3fr;
}
.sci-home-tbody2 tr td {
  padding: 10px 25px;
}
.sci-home-thead2 tr th {
  padding: 10px 0;
}
.sci-home-contIndicadores {
  display: grid;
  height: 35vh;
  background: #0084ff;
  align-content: center;
  grid-template-rows: 1fr;
  margin-top: 7%;
}
.sci-home-secIndicadores {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
}
.sci-home-Numeros {
  margin-bottom: 24.5vh;
}
.sci-home-tNumeros {
  padding: 6.7% 0 0;
  font-size: 2.4em;
  color: #0084ff;
  text-transform: uppercase;
  font-weight: bold;
}
.sci-home-numerosTexto {
  width: 45%;
  margin: auto;
  text-align: justify;
  font-size: 1.2em;
  line-height: 1.2;
}
.sci-home-indicador1,
.sci-home-indicador2 {
  display: grid;
  justify-content: center;
  align-content: center;
  font-size: 4.4em;
  color: #fff;
}
.sci-home-indicadorSpan1 {
  font-weight: bold;
}
.sci-home-indicadorSpan2 {
  color: #fff;
  font-size: 0.3em;
  text-transform: uppercase;
}
</style>
